const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

// Backend timestamps are naive UTC; the trailing Z is what the rest of the app assumes too.
const parseUtc = (value: string) => {
  const hasZone = /(?:[Zz]|[+-]\d{2}:?\d{2})$/.test(value);
  return new Date(hasZone ? value : `${value}Z`);
};

const unit = (value: number, name: string) => `${value}${name}`;

export const relativeFromNow = (value: string): string => {
  const delta = parseUtc(value).getTime() - Date.now();
  const magnitude = Math.abs(delta);
  const future = delta > 0;

  let label: string;
  if (magnitude < MINUTE) {
    return 'just now';
  } else if (magnitude < HOUR) {
    label = unit(Math.round(magnitude / MINUTE), 'm');
  } else if (magnitude < DAY) {
    label = unit(Math.round(magnitude / HOUR), 'h');
  } else if (magnitude < 30 * DAY) {
    label = unit(Math.round(magnitude / DAY), 'd');
  } else {
    label = unit(Math.round(magnitude / (30 * DAY)), 'mo');
  }

  return future ? `in ${label}` : `${label} ago`;
};

export const isOverdue = (value?: string | null): boolean =>
  !!value && parseUtc(value).getTime() < Date.now();
